module.exports = __webpack_public_path__ + "img/DSC_0411-3.88aa681e.jpeg";